module.exports = __webpack_public_path__ + "static/media/SF UI Display Bold.74234478.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Bold.woff
// module id = 218
// module chunks = 0